module.exports = [
  {
    __typename: 'WpPage_Pagebuilder_Layouts_TempPrivacy',
  },
]
